/* reset:
 *
 * Stub to include css reset
 *
 * Author: Niels Giesen
 * Copyright 2016 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  $(function () {});
})(jQuery, window, document);
